import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-column gr-6" }, [
    _c(
      "div",
      {
        staticClass: "px-2",
        class: _setup.isMobile ? "text-h6" : "text-h5 text-center",
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_setup.t("С нами работают", _setup.options)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _setup.isMobile
      ? _c(
          "div",
          { staticClass: "our-partners-list our-partners-list--sliding" },
          _vm._l(_setup.partnersByLines, function (partnersByLine, indexLine) {
            return _c(
              "div",
              {
                key: indexLine,
                style: { animationPlayState: _setup.animationState },
              },
              _vm._l(partnersByLine, function (partner, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "bg-gray-0 pa-5 elevation-1 rounded-sm",
                  },
                  [
                    _c(VImg, {
                      attrs: {
                        src: partner,
                        height: "48",
                        width: "108",
                        alt: "/",
                        contain: "",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "our-partners-list" },
          _vm._l(_setup.partners, function (partner, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "bg-gray-0 pa-5 elevation-1 rounded-sm",
              },
              [
                _c(VImg, {
                  staticClass: "mx-auto",
                  attrs: {
                    src: partner,
                    height: "82",
                    width: "171",
                    alt: "/",
                    contain: "",
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }